import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITraderConsulter } from "../interface/trade/Consulter/ITraderConsulter";
import { IResult } from "../interface/IResult";
import { ITraderConsulterCooperativa } from "../interface/trade/Consulter/ITraderConsulterCooperativa";

enum TraderConsulterServiceEnum {
  save = "",
  getById = "/",
  getAll = "/all",
  update = "",
  getAllModalities = "/modalities",
  getCooperativa = "/cooperativas"
}

export default class TraderConsulterService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trader/consulter");
  }

  public save = async data => await this.POST(TraderConsulterServiceEnum.save, data);
  public getById = async id => await this.GET(TraderConsulterServiceEnum.getById + id);

  public getAll = async (): Promise<IResult<ITraderConsulter[]>> => {
    const result: IResult<ITraderConsulter[]> = await this.GET(TraderConsulterServiceEnum.getAll);
    result.data = result.data.filter(p => p.name !== '').sort((a, b) => a.name.localeCompare(b.name));
    return result;
  }

  public update = async data => await this.PUT(TraderConsulterServiceEnum.save, data);
  public getAllModalities = async (): Promise<any> => await this.GET(TraderConsulterServiceEnum.getAllModalities);
  public getAllCooperativa = async (): Promise<IResult<ITraderConsulterCooperativa[]>> => this.GET(TraderConsulterServiceEnum.getCooperativa);

}



// WEBPACK FOOTER //
// ./src/services/api/TraderConsulter.service.ts